define('client',[
    'jquery',
    'underscore',
    'backbone',
    'marionette',
    'bootstrap',
    'modules/base/models/contract.entitlements.model',
    'modules/base/models/contract.model',
    'modules/base/models/contract.quotas.model',
    //'modules/auth/models/contract.tech.search.categories.model',
    //'modules/base/models/search.topic.collection',
    'modules/auth/models/session.model',
    'modules/settings/models/sales.force.details.model',
    //'modules/settings/models/boardex.details.model',
    //'modules/settings/models/skrapp.summary.model', //added
    'modules/base/models/redirect.model',
    'modules/base/models/token.model',
    'modules/base/models/user.model',
    'modules/base/models/utils.model',
     /*'modules/profiles/models/lastest.media.search.model',*/
    'modules/home/models/following.list.model'
], function($, _, Backbone,Marionette,Bootstrap,
            ContractEntitlementsModel,
            ContractModel,
            ContractQuotasModel,
            //TechSearchCategoriesModel,
            //SearchTopicsCollection,
            SessionModel,
            SalesForceDetailsModel,
            //BoardExDetailsModel,
            //SkrappSummaryModel, //added
            RedirectModel,
            TokenModel,
            UserModel,
            UtilsModel,
            /*LatestMediaSearchModel,*/
            FollowingListModel){

    var Prospector = new Marionette.Application();

    Prospector.navigate = function(route,  options){
        options || (options = {});
        Backbone.history.navigate(route, options);
    };

    Prospector.getCurrentRoute = function(){
        return Backbone.history.fragment
    };


    Prospector.startSubApp = function(appName, args){
        var currentApp = appName ? Prospector.module(appName) : null;
        if (Prospector.currentApp === currentApp){ return; }

        if (Prospector.currentApp){
            Prospector.currentApp.stop();
        }

        Prospector.currentApp = currentApp;
        if(currentApp){
            currentApp.start(args);
        }
    };

    Prospector.on( "loadCss", function(url) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        var a = Math.floor((Math.random() * 100000) + 1);
        link.href = url + "?version=" + a;
        document.getElementsByTagName("head")[0].appendChild(link);
    });

    Prospector.on("init", function(){ // 1
        //window.googleAnalyticsLoaded = false;
        //window.loadedScripts = new Array();
        window.auth = new RedirectModel();
        window.entitlements = new ContractEntitlementsModel();
        window.contract = new ContractModel();
        window.contractQuotas = new ContractQuotasModel();
        window.session = new SessionModel();
        //window.searchTopics = new SearchTopicsCollection();
        window.token = new TokenModel();
        window.user = new UserModel();
        window.utils = new UtilsModel();
        window.user.following = new FollowingListModel();
        /*window.techCategories = new TechSearchCategoriesModel();*/
        window.redirectUrl = "";
        window.salesforceSession = new SalesForceDetailsModel();
        // window.boardExSession = new BoardExDetailsModel();
        // window.skrappSummary = new SkrappSummaryModel(); //added
        Prospector.isFirstLoad = true;
        window.typeAheadWait = 850;
         /* var lpms = new LatestMediaSearchModel();
        lpms.identityType = 'person';

        var loms = new LatestMediaSearchModel();
        loms.identityType = 'organization';

        window.latestMediaSearch = {
            person: lpms,
            organization: loms
        } */
    });

    Prospector.on("before:start", function(){ // 2
        Prospector.trigger("init");
    });

    Prospector.on("start", function(){ // 3
        Prospector.addRegions({
            mainRegion: $("body"),
            modalRegion: '.modal-dialog'
        });
        
        if(Backbone.history) {
            $.ajaxSetup({
                cache: false,
                beforeSend: function (xhr)
                {
                    var unaToken = window.utils.readCookie('unaToken');
                    if(unaToken){
                        xhr.setRequestHeader("unaToken", unaToken);
                    }
                },
                complete: function (xhr)
                {
                    var unaToken = xhr.getResponseHeader('unaToken');
                    if(unaToken){
                        window.utils.createCookie('unaToken', unaToken,0.01);
                    }
                }
            });
            var clientFunc = function(clientId, accessToken){
                if (accessToken != undefined && accessToken != null){
                    $.ajaxSetup({
                        headers: {
                            'Authorization': 'Bearer ' + accessToken,
                            'client_id': clientId
                        }
                    });
                } else {
                    $.ajaxSetup({
                        headers: {
                            'client_id': clientId
                        }
                    });
                }
            };
            window.utils.readStorageField('accessToken')
            .then(function(token){
                if(window.utils.isChromeExt()){
                    clientFunc(window.utils.CHROME_CLIENT_ID, token);
                }else{
                    clientFunc(window.utils.MOBILE_CLIENT_ID_PROD, token);
                }

                require([
                    /*"modules/advanceSearch/advance.search.module",
                     "modules/alerts/alerts.module",
                     "modules/async/async.module", */
                    "modules/auth/auth.module",
                    "modules/base/base.module",
                    "modules/home/home.module",
                    "modules/profiles/profile.module",
                    "modules/settings/settings.module",
                    // "modules/boardex/boardex.module",
                    // "modules/bulkOperations/bulk.operations.module",
                    // "modules/bulkSourcing/bulk.sourcing.module",
                    "modules/lists/lists.module",
                    "modules/resolution/resolution.module"
                    /* "modules/techstack/techstack.module",
                     "modules/topicMaker/topic.maker.module",
                     "modules/userBins/user.bins.module"*/

                ], function (
                    AuthAppRouter,
                    BaseModule,
                    HomeAppRouter,
                    ProfileAppRouter,
                    SettingsAppRouter,
                    ListAppRouter,
                    ResolutionAppRouter

                    /*
                     BoardExApp,
                     BulkOperationsApp,
                     BulkSourcingApp,
                     ListAppRouter,

                     TechSearchAppRouter,
                     TopicMakerAppRouter,
                     UserBinModule */
                ) {
                    Backbone.history.start();
                    window.redirectUrl = Prospector.getCurrentRoute();
                    if( Prospector.getCurrentRoute() === ""){
                        Prospector.navigate('login', {trigger: true});
                    }
                });
            });
        }

    });
    window.app = Prospector;
    return Prospector;
});


